/**
 * mayaPortrait.js — iter278.4 (Feb 14, 2026)
 *
 * Single source of truth for Maya's portrait URL. Both the in-Studio
 * <MayaAvatar /> and the global <AIStylistFab /> + <AIStylistDrawer />
 * import from here, so when the boutique swaps the illustration the
 * next time, ONE line changes and every face on the storefront updates
 * together. No more 3-place string drift.
 *
 * Bump the ?v= suffix every time the underlying JPEG is replaced so
 * browsers fetch the new image instead of the cached old one.
 */
export const MAYA_PORTRAIT_URL = "/maya/portrait-v1.jpg?v=2";
